import { GradeTheme } from "@euka-mfes/bark";

const seniorGradeCodes: Record<number, GradeTheme> = {
  120: GradeTheme.Senior,
  110: GradeTheme.Senior
};

const secondaryGradeCodes: Record<number, GradeTheme> = {
  100: GradeTheme.Secondary,
  90: GradeTheme.Secondary,
  80: GradeTheme.Secondary,
  70: GradeTheme.Secondary
};

const primaryGradeCodes: Record<number, GradeTheme> = {
  60: GradeTheme.Primary,
  50: GradeTheme.Primary,
  40: GradeTheme.Primary,
  30: GradeTheme.Primary,
  20: GradeTheme.Primary,
  10: GradeTheme.Primary
};

const foundationGradeCodes: Record<number, GradeTheme> = {
  1: GradeTheme.Primary
};

const prepartoryGradeCodes: Record<number, GradeTheme> = {
  901: GradeTheme.Primary
};

export const getProductFamilyForGradeCode = (
  gradeCode: number
): string | undefined => {
  if (gradeCode in seniorGradeCodes) {
    return seniorGradeCodes[gradeCode];
  }
  if (gradeCode in secondaryGradeCodes) {
    return secondaryGradeCodes[gradeCode];
  }
  if (gradeCode in primaryGradeCodes) {
    return primaryGradeCodes[gradeCode];
  }
  if (gradeCode in foundationGradeCodes) {
    return foundationGradeCodes[gradeCode];
  }
  if (gradeCode in prepartoryGradeCodes) {
    return prepartoryGradeCodes[gradeCode];
  }
  return undefined;
};

export const getPlpGradeLabel = (plpGradeName: string): string => {
  if (!plpGradeName) return "";
  return ` (PLP - ${plpGradeName})`;
};
